import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SCAMP_API } from 'src/environments/environment';
import { TipoDeEquipamento } from '../pages/domain/domain.model';
import { AccountService } from './account.service';


@Injectable({ providedIn: 'root' })
export class TipoEquipamentoService {

    url = '';

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) {
        this.url = SCAMP_API.accountApiV1;
    }


    getAll(): Observable<TipoDeEquipamento[]> {
        return this.http.get<TipoDeEquipamento[]>(`${SCAMP_API.accountApiV1}/tiposequipamentos`, 
        { headers: this.account.composeHeaders() });
    }
   

    getById(id: number): Observable<TipoDeEquipamento> {
        return this.http.get<TipoDeEquipamento>(`${SCAMP_API.accountApiV1}/tiposequipamentos/${id}`,
            { headers: this.account.composeHeaders() });
    }

    isUnique(descricao: string): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/tiposequipamentos/descricao/isunique`, {descricao},
            { headers: this.account.composeHeaders() });
    }

    post(data: TipoDeEquipamento) {
        return this.http.post(`${SCAMP_API.accountApiV1}/tiposequipamentos`, data,
            { headers: this.account.composeHeaders() });
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/tiposequipamentos/${id}`,
            { headers: this.account.composeHeaders() });
    }

    

    
}
